import { ru, TranslationSchema } from './ru';
import { kk } from './kk';
import { en } from './en';

export type Locale = 'ru' | 'kk' | 'en';

export interface LanguageOption {
  code: Locale;
  label: string;
  shortLabel: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'ru', label: 'Русский', shortLabel: 'РУС' },
  { code: 'kk', label: 'Қазақша', shortLabel: 'ҚАЗ' },
  { code: 'en', label: 'English', shortLabel: 'ENG' },
];

export const translations: Record<Locale, TranslationSchema> = {
  ru,
  kk,
  en,
};

export { ru, kk, en };
export type { TranslationSchema };
